<template>
  <div class="content-container">
    <NavbarPublicCobre />
    <div class="background-zone">
      <v-row>
        <v-col cols="12" class="text-end">
          <button class="logout-button" @click="logOut">Cerrar sesión X</button>
        </v-col>
      </v-row>
      <v-row class="text-start ml-6 mt-4 mb-2">
        <v-col cols="12">
          <h1 class="text-white font-weight-bold">Investors</h1>
        </v-col>
      </v-row>
    </div>
    <v-container fluid class="container-data">
      <v-row class="text-start ml-4 mt-4 mb-2">
        <!-- Categorías -->
        <v-col cols="12" md="3" class="border-end">
          <v-divider class="custom-divider" />
          <v-btn
            variant="text"
            class="categorys"
            :class="{
              'selected_category font-weight-bold': selectedPage === 'news',
            }"
            style="justify-content: flex-start"
            @click="changePageNews()"
            block
          >
            News
          </v-btn>
          <v-divider class="custom-divider" />
          <div v-for="cat in categories" :key="cat" class="py-2">
            <v-btn
              variant="text"
              class="categorys"
              :class="{
                'selected_category font-weight-bold active':
                  selectedCategory &&
                  selectedCategory.category === cat.category,
              }"
              style="justify-content: flex-start"
              @click="selectedCategory = cat"
              block
            >
              {{ cat.category }}
            </v-btn>
            <v-divider class="custom-divider" />
          </div>
          <v-btn
            v-if="selectedCategory"
            size="x-small"
            variant="text"
            class="text-cleaner"
            @click="selectedCategory = null"
          >
            Limpiar categoría
          </v-btn>
        </v-col>

        <!-- Años -->
        <v-col cols="12" md="2" class="border-end" v-if="selectedCategory">
          <v-divider class="custom-divider" />
          <v-radio-group v-model="selectedYear" column>
            <v-radio
              v-for="year in years"
              :key="year.year"
              :label="year.year"
              :value="year.year"
              class="my-2 custom-radio"
              :class="{ 'custom-radio--selected': selectedYear === year.year }"
            />
          </v-radio-group>
          <v-btn
            v-if="selectedYear"
            size="x-small"
            variant="text"
            class="text-cleaner"
            @click="selectedYear = null"
          >
            Limpiar año
          </v-btn>
        </v-col>

        <!-- Trimestres -->
        <v-col cols="12" md="2" class="border-end" v-if="selectedYear">
          <v-divider class="custom-divider" />
          <v-radio-group v-model="selectedQuarter" column>
            <v-radio
              v-for="quarter in quarters"
              :key="quarter"
              :label="quarter"
              :value="quarter"
              class="my-2 custom-radio"
              :class="{ 'custom-radio--selected': selectedQuarter === quarter }"
            />
          </v-radio-group>
          <v-btn
            v-if="selectedQuarter"
            size="x-small"
            variant="text"
            class="text-cleaner"
            @click="selectedQuarter = null"
          >
            Limpiar trimestre
          </v-btn>
        </v-col>

        <!-- Archivos -->
        <v-col cols="12" md="5" v-if="selectedQuarter">
          <v-list two-line>
            <v-list-item
              v-for="item in filesContent"
              :key="item.file_name"
              @click="seeMore(item)"
              class="hoverable"
            >
              <v-row no-gutters>
                <v-col cols="1" class="d-flex justify-end align-start">
                  <img
                    src="../../../assets/flechita-cobre.svg"
                    width="24"
                    alt=""
                  />
                </v-col>
                <v-col cols="11">
                  <v-list-item class="d-flex align-center">
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="font-weight-bold">
                        {{ item.file_name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ dateFormat(item.created_at) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    <footer-component-cobre />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { getFiles } from "../services/files-service";
import { BASEURL, formatDate } from "@/kernel/utils";
import { showErrorToast } from "@/kernel/alerts";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import FooterComponentCobre from "@/components/FooterCobre.vue";
import NavbarPublicCobre from "@/components/NavbarPublicCobre.vue";

const files = ref({ content: [] });
const originalFiles = ref([]);
const itemsPerPage = ref(3000);
const loading = ref(false);

const selectedCategory = ref(null);
const selectedQuarter = ref(null);
const selectedYear = ref(null);

const router = useRouter();
const route = useRoute();

const changePageNews = async () => {
  await router.push({ name: "news-investors" });
};

const categories = ref([
  { category: "Offering Memorandum" },
  { category: "Financial Statements" },
]);

const quarters = ref(["Q1", "Q2", "Q3", "Q4"]);
const years = ref([]);

const filesContent = computed(() => files.value.content);

const dateFormat = (date) => {
  return formatDate(date);
};

const seeMore = async (file) => {
  const link = BASEURL + file.file_path;

  const newTab = window.open("about:blank", "_blank");

  try {
    const response = await fetch(link, {
      method: "GET",
      headers: {
        Range: "bytes=0-1",
      },
    });

    if (response.ok) {
      newTab.location.href = link;
    } else {
      newTab.close();
      showErrorToast("El documento no existe");
    }
  } catch (error) {
    newTab.close();
    console.error("Error checking document:", error);
    showErrorToast("Error al verificar el documento");
  }
};

const loadItems = async () => {
  loading.value = true;
  try {
    const params = { page: 0, size: itemsPerPage.value };
    const result = await getFiles(params);
    if (result && result.status === 200) {
      originalFiles.value = result.data.content;
      files.value.content = result.data.content;
      if (result.data.categories.length > 0) {
        categories.value = result.data.categories;
      }
      updateFilteredData();
    }
  } catch (error) {
    console.error("Error al cargar archivos:", error);
  } finally {
    loading.value = false;
  }
};

const updateFilteredData = () => {
  const filtered = originalFiles.value.filter((file) => {
    const matchesCategory =
      !selectedCategory.value ||
      (selectedCategory.value &&
        selectedCategory.value.category &&
        file.category === selectedCategory.value.category);

    const matchesYear = !selectedYear.value || file.year === selectedYear.value;
    const matchesQuarter =
      !selectedQuarter.value || file.quarter === selectedQuarter.value;
    return matchesCategory && matchesYear && matchesQuarter;
  });

  files.value.content = filtered;

  const filteredByCategory = originalFiles.value.filter(
    (f) =>
      !selectedCategory.value || f.category === selectedCategory.value.category
  );
  const uniqueYears = [...new Set(filteredByCategory.map((f) => f.year))].sort(
    (a, b) => b - a
  );
  years.value = uniqueYears.map((y) => ({ year: y }));

  const filteredByYear = filteredByCategory.filter(
    (f) => !selectedYear.value || f.year === selectedYear.value
  );
  const uniqueQuarters = [
    ...new Set(filteredByYear.map((f) => f.quarter)),
  ].sort();
  quarters.value = uniqueQuarters;
};

const logOut = () => {
  localStorage.removeItem("token");
  router.push({ name: "admin" });
};

onMounted(async () => {
  const incomingCategory = route.query.category;

  if (incomingCategory) {
    selectedCategory.value = { category: incomingCategory };
  }

  await loadItems(); // espera a que cargue
  updateFilteredData(); // ahora sí, con categoría ya lista
});

watch([selectedCategory, selectedQuarter, selectedYear], () => {
  updateFilteredData();
});

watch(selectedCategory, () => {
  selectedYear.value = null;
  selectedQuarter.value = null;
});

watch(selectedYear, () => {
  selectedQuarter.value = null;
});
</script>

<style scoped>
:deep(*) {
  font-family: "Now", sans-serif !important;
}

.hoverable {
  transition: background-color 0.2s ease;
}
.hoverable:hover {
  background-color: #f5f5f5;
}

.content-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container-data {
  flex: 1;
}

h1 {
  position: relative;
  display: inline-block;
  font-size: 2.5rem;
  line-height: 2.5rem;
  font-weight: bold;
  font-family: "Now";
  color: white;
  z-index: 1;
}

h1::before {
  content: "";
  position: absolute;
  bottom: 0.2rem; /* cerca de la base del texto */
  left: 0;
  width: 100%; /* que cubra todo el texto */
  height: 1rem; /* menos alto para parecer subrayado */
  background-color: rgba(241, 90, 41, 0.6);
  z-index: -1;
}

.background-zone {
  height: 18rem;
  width: 100%;
  background-image: url("../../../assets/mine2.jpg");
  background-size: cover;
  background-position: center;
}

.custom-divider {
  background-color: #000000 !important;
  height: 10px !important;
  opacity: 1 !important;
}

.text-cleaner {
  color: #df6439 !important;
  font-size: 0.6rem !important;
}

.categorys {
  font-weight: bold;
  font-size: 1rem;
}

.selected_category {
  background-color: white !important;
  color: #df6439 !important;
  font-weight: bold !important;
  font-size: 1rem;
}

:deep(.custom-radio .v-icon.mdi-radiobox-blank) {
  color: grey !important;
}

:deep(.custom-radio .v-icon.mdi-radiobox-marked) {
  color: #df6439 !important;
  font-weight: bold !important;
}

:deep(.custom-radio .v-label) {
  font-weight: bold !important;
  color: grey !important;
}

:deep(.custom-radio--selected .v-label) {
  color: black !important;
  opacity: 1 !important;
}

.logout-button {
  background-color: #df6439;
  border: none;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 128px;
  margin-right: 32px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.logout-button:hover {
  background-color: darken(#df6439, 60%);
}
</style>
